








































































































import Vue from 'vue'

import BasePanel from 'base/components/BasePanel.vue'
import ConfirmDeleteWidgetDialog from '../dialogs/ConfirmDeleteWidgetDialog.vue'
import SettingsPanelCustomCheckbox from './SettingsPanelCustomCheckbox.vue'
import SettingsPanelCustomCheckboxList from './SettingsPanelCustomCheckboxList.vue'
import SettingsPanelCustomCustom from './SettingsPanelCustomCustom.vue'
import SettingsPanelCustomSelectbox from './SettingsPanelCustomSelectbox.vue'
import SettingsPanelCustomSortableList from './SettingsPanelCustomSortableList.vue'
import SettingsPanelCustomSortableCheckboxList from './SettingsPanelCustomSortableCheckboxList.vue'
import SettingsPanelCustomText from './SettingsPanelCustomText.vue'
import SettingsPanelCustomNumber from './SettingsPanelCustomNumber.vue'
import CustomSection from './SettingsPanelCustomSection.vue'

import { EventService } from '../../base/services/EventService'
import { Widget } from '../widgets/base'
import { DragDropOperationStatus, DragDropService } from '../widgets/base/drag-drop'
import { PermutatorService } from '../widgets/base/permutator'
import { ResizeService } from '../widgets/base/resize'
import { WidgetSettingType } from '../widgets/base/widget/WidgetInterface'
import { WidgetService } from '../widgets/base/widget/WidgetService'
import { WidgetHeightType } from '../widgets/base/widget/WidgetTypes'

export default Vue.extend({
  components: {
    BasePanel,
    SettingsPanelCustomCheckbox,
    SettingsPanelCustomCheckboxList,
    SettingsPanelCustomText,
    SettingsPanelCustomNumber,
    SettingsPanelCustomSelectbox,
    SettingsPanelCustomSortableList,
    SettingsPanelCustomSortableCheckboxList,
    SettingsPanelCustomCustom,
    CustomSection,
    ConfirmDeleteWidgetDialog
  },
  data() {
    return {
      deselectWidgetOnClick: false,
      widgetLoaded: false,
      widget: null as Widget | null,
      widgetPristine: null as Widget | null,
      isPristine: true,
      availableWidgetSizes: [] as number[],
      notEditableFields: [] as string[],
      ignoreUpdateOnce: false,
      selectedHeightType: WidgetHeightType.automatic,
      hasBeenResetted: false,
      fixedHeightTypesAllowed: true,
      flexibleHeightTypesAllowed: true,
      maxValidHeightInput: -1,
      doShowConfirmDeleteDialog: false
    }
  },
  computed: {
    customSections() {
      const result: any[] = []

      const customSettings = this.widget!.customSettings

      if (!customSettings) return result

      const settings = customSettings.settings

      if (!settings) return result

      const defaultSection = { settings: {} }

      if (!customSettings.sections) {
        for (let key in settings) {
          if (!settings.hasOwnProperty(key)) continue
          defaultSection.settings[key] = settings[key]
        }

        result.push(defaultSection)
        return result
      }

      // holds all settings that are located in a section
      // used to find settings that aren't located in any sections
      const categorizedSettings = {}

      customSettings.sections.forEach(sectionDetails => {
        const sectionSettings = sectionDetails.settings
        const sectionLabel = sectionDetails.label
        const section = {
          label: sectionLabel,
          settings: {}
        }

        sectionSettings.forEach(settingKey => {
          if (!settings.hasOwnProperty(settingKey)) {
            return
          }
          categorizedSettings[settingKey] = true
          section.settings[settingKey] = settings[settingKey]
        })

        result.push(section)
      })

      let hasDefaultSectionSettings = false

      // find settings that aren't located in a section and add them to the default section
      for (let settingName in settings) {
        if (!settings.hasOwnProperty(settingName) || categorizedSettings[settingName]) {
          continue
        }
        defaultSection.settings[settingName] = settings[settingName]
        hasDefaultSectionSettings = true
      }

      if (hasDefaultSectionSettings) {
        result.unshift(defaultSection)
      }

      return result
    },
    isContainer(): boolean {
      return !!this.widget && !!this.widget.rows
    },
    heightUnit(): string {
      if (!this.widget) return ''

      switch (this.widget.heightType) {
      case WidgetHeightType.pixel:
        return 'Pixel'
      case WidgetHeightType.percentage:
        return '%'
      case WidgetHeightType.grid:
        return 'Anzahl Rasterzeilen'
      default:
        return 'Zahl'
      }
    },
    isEditableHeightType(): boolean {
      if (!this.widget) return false

      return this.widget.heightType !== WidgetHeightType.automatic
              && this.widget.heightType !== WidgetHeightType.remaining
    },
    /*
    Optionen:

    1. Automatische Höhe
    2. Maixmal verfügbare Höhe
    3. Prozentualer Wert
    4. Raster
    5. Pixelgenau

    Fall 1: Container = Raster
    Inhalt: 1. Automatische Höhe
            2. Maximal verfügbare Höhe
            4. Raster

    Fall 2: Container = Pixelgenau
    Inhalt: 1. Automatische Höhe
            2. Maixmal verfügbare Höhe
            3. Prozentualer Wert
            4. Pixelgenau

    Fall 3: Container = Automatisch (gilt auch für Root Container)
    Inhalt: 1. Automatische Höhe
            3. Pixelgenau
            4. Raster

    Fall 4   : Inhalt = Pixel
    Container: 1. Automatische Höhe
               2. Pixelgenau

    Fall 5   : Inhalt = Proznet
    Container: 1. Automatische Höhe
               3. Pixelgenau

    Fall 6   : Inhalt = Raster
    Container: 1. Automatische Höhe
               3. Raster

     Fall 7:   Container = Viewport
     Inhalt: Nur prozentual
     */
    availableHeightTypes() {
      const widget = this.widget

      if (!widget) return []

      const heightTypeAutomatic = { type: WidgetHeightType.automatic, label: 'Automatische Höhe' }
      const heightTypeRemaining = { type: WidgetHeightType.remaining, label: 'Maximal verfügbare Höhe' }
      const heightTypePercentage = { type: WidgetHeightType.percentage, label: 'Prozentualer Wert' }
      const heightTypeGrid = { type: WidgetHeightType.grid, label: 'Raster' }
      const heightTypePixel = { type: WidgetHeightType.pixel, label: 'Pixelgenaue Angabe' }

      const selectedHeightTypes = {
        heightTypeAutomatic: true,
        heightTypeRemaining: false,
        heightTypePercentage: false,
        heightTypeGrid: false,
        heightTypePixel: false
      }

      const container = PermutatorService.getWidgetContainer(widget.wbUUID!)

      let parentContainerHeightType = container.heightType

      if (PermutatorService.isRootContainer(container.wbUUID!)) {
        parentContainerHeightType = WidgetHeightType.automatic
      }

      switch (parentContainerHeightType) {
      case WidgetHeightType.automatic:
        selectedHeightTypes.heightTypeGrid = true
        selectedHeightTypes.heightTypePixel = true
        break
      case WidgetHeightType.grid:
        selectedHeightTypes.heightTypeRemaining = true
        selectedHeightTypes.heightTypeGrid = true
        break
      case WidgetHeightType.pixel:
        selectedHeightTypes.heightTypeRemaining = true
        selectedHeightTypes.heightTypePercentage = true
        selectedHeightTypes.heightTypePixel = true
        break
      default:
        // do nothing
        break
      }

      if (this.isContainer) {
        const childWidgets = PermutatorService.getNestedChildren(widget)
        const numWidgets = childWidgets.length
        let childHasPixel = false
        let childHasGrid = false
        let childHasPercentage = false

        let i = 0
        for (; i < numWidgets; i++) {
          const heightType = childWidgets[i].heightType

          if (heightType === WidgetHeightType.pixel) {
            childHasPixel = true
            break
          }

          if (heightType === WidgetHeightType.grid) {
            childHasGrid = true
            break
          }

          if (heightType === WidgetHeightType.percentage) {
            childHasPercentage = true
            break
          }
        }

        if (childHasGrid || childHasPixel || childHasPercentage) {
          selectedHeightTypes.heightTypePercentage = false
          selectedHeightTypes.heightTypeRemaining = false
        }

        if (childHasGrid) {
          selectedHeightTypes.heightTypePixel = false
        }

        if (childHasPixel || childHasPercentage) {
          selectedHeightTypes.heightTypeGrid = false
        }
      }

      const result: any = []

      if (selectedHeightTypes.heightTypeAutomatic) result.push(heightTypeAutomatic)
      if (selectedHeightTypes.heightTypeRemaining) result.push(heightTypeRemaining)
      if (selectedHeightTypes.heightTypePercentage) result.push(heightTypePercentage)
      if (selectedHeightTypes.heightTypeGrid) result.push(heightTypeGrid)
      if (selectedHeightTypes.heightTypePixel) result.push(heightTypePixel)

      return result
    },
    isTitleEditable(): boolean {
      return this.isEditable('title')
    },
    isSizeEditable(): boolean {
      return this.isEditable('size')
    },
    isHeightEditable(): boolean {
      return this.isEditable('height')
    }
  },
  methods: {
    onDeleteWidget(widget: Widget) {
      this.onCloseConfirmDeleteDialog()

      const widgetUUID = widget.wbUUID!
      const row = PermutatorService.getParentRow(widgetUUID)!

      if (!row) return

      PermutatorService.removeItemFromRow(row, widgetUUID)
      PermutatorService.handleDeleteZoneDrop(row)
      EventService.$emit('widget-select', null)
    },
    onCloseConfirmDeleteDialog() {
      this.doShowConfirmDeleteDialog = false
    },
    onConfirmWidgetDelete() {
      this.doShowConfirmDeleteDialog = true
    },
    isEditable(propName: string): boolean {
      return this.notEditableFields.indexOf(propName) === -1
    },
    onSelectWidget(component) {
      const widget = component ? JSON.parse(JSON.stringify(component.widget)) : null
      this.ignoreUpdateOnce = true
      this.widgetLoaded = widget !== null
      this.widget = widget
      this.widgetPristine = JSON.parse(JSON.stringify(widget))
      this.availableWidgetSizes = []
      this.notEditableFields = []
      this.isPristine = true

      if (!this.widgetLoaded) return

      this.selectedHeightType = widget.heightType

      const specs = WidgetService.getWidgetSpecification(widget.type)
      if (!specs) return

      if (specs.notEditable && specs.notEditable.length) {
        this.notEditableFields = [...specs.notEditable]
      }

      let maxSize = specs.maxSize || 32
      const row = PermutatorService.getParentRow(widget.wbUUID)
      const numColsAvailableInRow = row ? (PermutatorService.getRemainingColCount(row) + widget.size) : 0

      if (maxSize > numColsAvailableInRow) {
        maxSize = numColsAvailableInRow
      }

      for (let i = specs.minSize || 1; i <= maxSize;i++) {
        this.availableWidgetSizes.push(i)
      }

      this.calculateMaxValidHeightInput()
    },
    onReset() {
      this.hasBeenResetted = true
      this.widget = JSON.parse(JSON.stringify(this.widgetPristine))
      this.setPristineState()
    },
    setPristineState() {
      const widget = this.widget
      const widgetPristine = this.widgetPristine

      let isPristine = true
      for (const prop in widget) {
        if (!widget.hasOwnProperty(prop)) continue

        if (!widgetPristine) break

        if (JSON.stringify(widgetPristine[prop]) !== JSON.stringify(widget[prop])) {
          isPristine = false
          break
        }
      }

      this.isPristine = isPristine
    },
    calculateMaxValidHeightInput() {
      const widget = this.widget
      let maxValidHeight = -1

      if (widget) {
        maxValidHeight = ResizeService.getMaxValidHeightForWidget(widget)
      }

      this.maxValidHeightInput = maxValidHeight
    },
    processCustomSettings(widget: Widget) {
      const customSettings = widget.customSettings

      if (!customSettings) return

      const settings = customSettings.settings

      if (!settings) return

      for (let settingName in settings) {
        if (!settings.hasOwnProperty(settingName)) {
          continue
        }

        const setting = settings[settingName]

        // currently checkbox lists are the only setting type we need to process
        if (setting.type !== WidgetSettingType.checkboxList) {
          continue
        }

        setting.values = []

        const list = setting.list
        for (let cboxName in list) {
          if (!list.hasOwnProperty(cboxName)) {
            continue
          }
          const cbox = list[cboxName]
          if (!cbox.checked) {
            continue
          }
          setting.values.push(cbox.value || cboxName)
        }
      }
    },
    onUpdate() {
      if (this.ignoreUpdateOnce) {
        this.ignoreUpdateOnce = false
        return
      }

      const widget = this.widget

      if (!widget) return

      // do we need to initialize the value for a newly selected height type?
      if (!this.hasBeenResetted && (this.selectedHeightType !== widget.heightType)) {
        widget.height = ResizeService.getInitialHeightTypeValue(widget)
        this.calculateMaxValidHeightInput()
      }

      this.selectedHeightType = widget.heightType!

      const minHeight = ResizeService.getMinHeightForWidget(widget, widget.heightType!)

      // apply min height only if it doesn't exceed the maximum allowed value
      if ((widget.height! < minHeight) && (this.maxValidHeightInput > -1) && (minHeight < this.maxValidHeightInput)) {
        widget.height = minHeight
      }

      if ((this.maxValidHeightInput > -1) && (widget.height! > this.maxValidHeightInput)) {
        widget.height = this.maxValidHeightInput
      }

      this.processCustomSettings(widget)

      EventService.$emit('widget-update', widget.wbUUID, widget)

      this.setPristineState()

      this.hasBeenResetted = false
    }
  },
  updated() {
    // Bug Workaround
    // SettingsPanel was interfering with the changes made to the widget by DragDropService
    if (DragDropService.getDragDropStatus() === DragDropOperationStatus.dragging) {
      this.ignoreUpdateOnce = true
      return
    }
    this.onUpdate()
  },
  created() {
    EventService.$on('widget-select', this.onSelectWidget)

    window.addEventListener('mousedown', e => {
      let el = e.target as HTMLElement
      let deselectWidget = true

      while ((el !== null) && (el.nodeType === 1)) {
        // sometimes el.className is not a string but an object
        // tslint:disable-next-line: strict-type-predicates
        let classes = (typeof el.className === 'string') ? el.className.split(' ') : []
        if (
          (classes.indexOf('widget') > -1) ||
          (classes.indexOf('settings--area') > -1) ||
          (classes.indexOf('base--dialog') > -1)
        ) {
          deselectWidget = false
          break
        }
        el = el.parentNode as HTMLElement
      }
      this.deselectWidgetOnClick = deselectWidget
    })
    window.addEventListener('mouseup', e => {
      if (this.deselectWidgetOnClick && this.widget) {
        EventService.$emit('widget-select', null)
      }
    })
  },
  destroyed() {
    EventService.$off('widget-select', this.onSelectWidget)
  }
})
